import signedFetch from '../apiCalls/util/signedFetch';

// @ts-ignore
const getSubmitTaskAssignments = () => `${__API_BASE__}/task-assignments/`;

export default function* submitTaskAssignmentsFetch(body) {
  return yield signedFetch('submitTaskAssignments', getSubmitTaskAssignments(), 'POST', body);
}
